import BudgetYear from '@api/BudgetYear'
import FormEditBudgetYear from '@components/form/budget_year/FormEditBudgetYear'
import LoadingPage from '@components/loading/LoadingPage'
import PageLayout from '@components/page/PageLayout'
import PageNotFound404 from '@pages/PageNotFound404'
import { useParams } from 'react-router-dom'

const EditBudgetYear = () => {
    const params = useParams()
    const budget_year = params.budget_year
    const { isLoading, isError, data, isRefetching } =
        BudgetYear.useGetBudgetYearByID({
            budget_year: budget_year!,
        })
    if (isLoading || isRefetching) {
        return <LoadingPage />
    }
    if (isError || data === undefined) {
        return (
            <PageNotFound404
                label='กลับไปหน้าปีงบประมาณทั้งหมด'
                url='/budgetyears'
            />
        )
    }
    return (
        <PageLayout pageTitle='แก้ไขปีงบประมาณ'>
            <FormEditBudgetYear data={data} />
        </PageLayout>
    )
}

export default EditBudgetYear
